// Backend API base URL, resolved at RUNTIME so one published package can serve
// every environment (the widgets are consumed pre-built from the npm registry —
// a build-time env var is compiled into the bundle and can never differ between
// the host app's dev/uat/prod deployments).
//
// Resolution order:
//   1. window.__BELLFG_API_URL__ — set by the embedding/host app before the
//      bundle runs (the EKS builds of bell-fg-widget set it per environment
//      from their config/.env.eks.* files).
//   2. REACT_APP_API_URL — build-time env, unchanged behaviour for the demo
//      app and any consumer that builds from source.
//   3. The legacy proxy — unchanged behaviour for existing embeds that set
//      neither of the above.

export function apiBase(): string {
  if (typeof window !== 'undefined') {
    const override = (window as { __BELLFG_API_URL__?: unknown }).__BELLFG_API_URL__;
    if (typeof override === 'string' && override) {
      return override;
    }
  }
  return process.env.REACT_APP_API_URL || 'https://t1hkhsm5.trkd-hs.com/belldevapi';
}
